module.exports = __webpack_public_path__ + "img/Tessellate21.0663a8eb.jpg";